import _slicedToArray from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { useState } from 'react';
import { apiQueryChatHistoryMessage } from '../../api/chat/common';
import { REQUEST_SUCCESS_CODE } from '../../constants';
var CHAT_HISTORY_PAGE_SIZE = 100;
export var useChatHistoryMessage = function useChatHistoryMessage() {
  var _useState = useState(),
      historyBefore = _useState[0],
      setHistoryBefore = _useState[1];

  var _useState2 = useState(false),
      canLoadMoreHistory = _useState2[0],
      setCanLoadMoreHistory = _useState2[1];

  var _useState3 = useState(false),
      isLoadingMoreHistory = _useState3[0],
      setIsLoadingMoreHistory = _useState3[1];
  /**
   * methods
   */


  var requestChatMessageList = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(item, config) {
      var params, _yield$apiQueryChatHi, _yield$apiQueryChatHi2, res, list, before, _res$data, _list, _list$, _list2;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              params = {
                limit: (config === null || config === void 0 ? void 0 : config.limit) || CHAT_HISTORY_PAGE_SIZE
              };

              if (item !== null && item !== void 0 && item.phone) {
                params['phone_number'] = item === null || item === void 0 ? void 0 : item.phone;
              }

              if (item !== null && item !== void 0 && item.email) {
                params['email'] = item === null || item === void 0 ? void 0 : item.email;
              }

              if (config !== null && config !== void 0 && config.before) {
                params['before'] = config.before;
              }

              _context.next = 6;
              return apiQueryChatHistoryMessage(params);

            case 6:
              _yield$apiQueryChatHi = _context.sent;
              _yield$apiQueryChatHi2 = _slicedToArray(_yield$apiQueryChatHi, 1);
              res = _yield$apiQueryChatHi2[0];
              list = [];
              before = null;

              if ((res === null || res === void 0 ? void 0 : res.code) === REQUEST_SUCCESS_CODE) {
                list = ((_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.data) || [];
                before = (_list = list) === null || _list === void 0 ? void 0 : (_list$ = _list[0]) === null || _list$ === void 0 ? void 0 : _list$.created_at;
                setHistoryBefore(before);
                setCanLoadMoreHistory(((_list2 = list) === null || _list2 === void 0 ? void 0 : _list2.length) >= ((config === null || config === void 0 ? void 0 : config.limit) || CHAT_HISTORY_PAGE_SIZE));
              }

              return _context.abrupt("return", {
                list: list,
                before: before
              });

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function requestChatMessageList(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();

  var requestHistoryChatMessageList = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(item, config) {
      var listRes;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setIsLoadingMoreHistory(true);
              _context2.next = 3;
              return requestChatMessageList(item, config);

            case 3:
              listRes = _context2.sent;
              setIsLoadingMoreHistory(false);
              return _context2.abrupt("return", {
                list: listRes.list
              });

            case 6:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function requestHistoryChatMessageList(_x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }();
  /**
   * methods
   */


  var cleanChatHistoryRelatedInfo = function cleanChatHistoryRelatedInfo() {
    setHistoryBefore(undefined);
    setCanLoadMoreHistory(false);
    setIsLoadingMoreHistory(false);
  };

  return {
    canLoadMoreHistory: canLoadMoreHistory,
    setCanLoadMoreHistory: setCanLoadMoreHistory,
    isLoadingMoreHistory: isLoadingMoreHistory,
    setIsLoadingMoreHistory: setIsLoadingMoreHistory,
    historyBefore: historyBefore,
    setHistoryBefore: setHistoryBefore,
    cleanChatHistoryRelatedInfo: cleanChatHistoryRelatedInfo,
    requestChatMessageList: requestChatMessageList,
    requestHistoryChatMessageList: requestHistoryChatMessageList
  };
};